<template>
  <!-- BEGIN pos-mobile-sidebar-toggler -->
  <a
    href="#"
    class="pos-mobile-sidebar-toggler"
    v-on:click="$emit('pos-mobile-sidebar-toggled')"
  >
    <svg
      viewBox="0 0 16 16"
      class="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
      />
      <path
        d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z"
      />
    </svg>
    <span class="badge">{{ dataSend.products.length }}</span>
  </a>
  <!-- END pos-mobile-sidebar-toggler -->
</template>

<script>
export default {
  name: 'MobileSidebarToggler',
  props: {
    dataSend: Object
  }
}
</script>

<style scoped>
/* No additional styles needed as they're in the main component */
</style>